var map = {
  "./applications.json": "90025",
  "./apps.json": "93790",
  "./attachment_relations.json": "877",
  "./boarding.json": "85318",
  "./calendar.json": "22840",
  "./common.json": "33463",
  "./customizable_table.json": "8809",
  "./dashboard.json": "48690",
  "./job_ads.json": "79396",
  "./layouts.json": "32085",
  "./mailer.json": "20426",
  "./modules.json": "80379",
  "./news.json": "78213",
  "./payments.json": "69073",
  "./permission_presets.json": "73626",
  "./posting_orders.json": "78092",
  "./search.json": "32714",
  "./skills.json": "67007",
  "./statistics.json": "34589",
  "./support.json": "61777",
  "./time_tracking.json": "59621",
  "./wizard_settings.json": "35215"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 28859;
